const initialState = {
  byWidgetId: {}
};

const parnasReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PARNAS_START':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            ...state.byWidgetId[action.payload.widgetId],
            loading: true,
            error: null
          }
        }
      };

    case 'FETCH_PARNAS_SUCCESS':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            loading: false,
            error: null,
            data: action.payload.data
          }
        }
      };

    case 'FETCH_PARNAS_FAILURE':
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [action.payload.widgetId]: {
            ...state.byWidgetId[action.payload.widgetId],
            loading: false,
            error: action.payload.error
          }
        }
      };

    default:
      return state;
  }
};

export default parnasReducer;
